/* import __COLOCATED_TEMPLATE__ from './external-profiles-display-component.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();